import { render, staticRenderFns } from "./CheckBox.vue?vue&type=template&id=32a52bd7&scoped=true&"
import script from "./CheckBox.vue?vue&type=script&lang=js&"
export * from "./CheckBox.vue?vue&type=script&lang=js&"
import style0 from "./Style/checkbox.scss?vue&type=style&index=0&id=32a52bd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a52bd7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32a52bd7')) {
      api.createRecord('32a52bd7', component.options)
    } else {
      api.reload('32a52bd7', component.options)
    }
    module.hot.accept("./CheckBox.vue?vue&type=template&id=32a52bd7&scoped=true&", function () {
      api.rerender('32a52bd7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Components/Inputs/CheckBox.vue"
export default component.exports